import {
  animate,
  style,
  transition,
  trigger,
  state,
  query,
  group,
} from '@angular/animations';
import { isPlatformBrowser } from '@angular/common';
import { Component, Inject, PLATFORM_ID } from '@angular/core';

@Component({
  selector: 'app-features-card',
  templateUrl: './features-card.component.html',
  styleUrls: ['./features-card.component.scss'],
  standalone: false,
  animations: [
    trigger('rightImageAnimation', [
      transition(':enter', [
        style({ transform: 'translateX(100%)', opacity: 0 }),
        animate(
          '0.8s ease-out',
          style({ transform: 'translateX(0)', opacity: 1 })
        ),
      ]),
      transition(':leave', [
        animate(
          '0.8s ease-out',
          style({ transform: 'translateY(-100%)', opacity: 0 })
        ),
      ]),
    ]),

    trigger('leftContentAnimation', [
      transition(':enter', [
        style({ transform: 'translateY(100%)', opacity: 0 }),
        animate(
          '0.8s ease-out',
          style({ transform: 'translateY(0)', opacity: 1 })
        ),
      ]),
      transition(':leave', [
        animate(
          '0.8s ease-out',
          style({ transform: 'translateX(-100%)', opacity: 0 })
        ),
      ]),
    ]),

    trigger('cardAnimation', [
      transition('* => *', [
        query(
          ':enter, :leave',
          style({ position: 'absolute', width: '100%' }),
          { optional: true }
        ),

        group([
          query(
            ':enter',
            [
              style({ opacity: 0 }),
              animate('0.8s ease-out', style({ opacity: 1 })),
            ],
            { optional: true }
          ),

          query(
            ':leave',
            [
              style({ opacity: 1 }),
              animate('0.8s ease-out', style({ opacity: 0 })),
            ],
            { optional: true }
          ),
        ]),
      ]),
    ]),
  ],
})
export class FeaturesCardComponent {
  slides = [
    {
      id: 1,
      title: 'Built for everyone in your ecosystem.',
      leftWrapper: {
        image:
          'https://inforida.ams3.cdn.digitaloceanspaces.com/assets/admin-staff-image.jpg',
        title: 'Admin staff',
        description:
          'Class Attendance, Homework & Assignment, Student Performance, Send Reminders & Alerts',
        link: '',
        shape: 'square',
      },
      rightImage:
        'https://inforida.ams3.cdn.digitaloceanspaces.com/assets/admin-staff-image.jpg',
    },
    {
      id: 2,
      title: 'Built for everyone in your ecosystem.',
      leftWrapper: {
        image:
          'https://inforida.ams3.cdn.digitaloceanspaces.com/assets/academic-staff.jpg',
        title: 'Academic staff',
        description:
          'Class Attendance, Homework & Assignment, Student Performance, Send Reminders & Alerts',
        link: '',
        shape: 'triangle',
      },
      rightImage:
        'https://inforida.ams3.cdn.digitaloceanspaces.com/assets/academic-staff.jpg',
    },
    {
      id: 3,
      title: 'Built for everyone in your ecosystem.',
      leftWrapper: {
        image:
          'https://inforida.ams3.cdn.digitaloceanspaces.com/assets/parents-main-image.jpg',
        title: 'Parents',
        description:
          'Class Attendance, Homework & Assignment, Student Performance, Send Reminders & Alerts',
        link: '',
        shape: 'circle',
      },
      rightImage:
        'https://inforida.ams3.cdn.digitaloceanspaces.com/assets/parents-main-image.jpg',
    },
  ];
  isBrowser: boolean = false;

  constructor(@Inject(PLATFORM_ID) private platformId: Object) {}

  activeIndex: number = 0;
  prevIndex: number | null = null;
  isAnimating: boolean = false;
  private autoPlayInterval: any;

  ngOnInit(): void {
    this.isBrowser = isPlatformBrowser(this.platformId);
    this.startAutoPlay();
  }

  ngOnDestroy(): void {
    this.stopAutoPlay();
  }

  private startAutoPlay(): void {
    if (this.isBrowser) {
      this.autoPlayInterval = setInterval(() => {
        this.handleNext();
      }, 5000);
    }
  }

  private stopAutoPlay(): void {
    if (this.autoPlayInterval) {
      clearInterval(this.autoPlayInterval);
    }
  }

  private handleSlideChange(nextIndex: number): void {
    if (this.isAnimating) return;

    this.isAnimating = true;
    this.prevIndex = this.activeIndex;
    if (this.isBrowser) {
      setTimeout(() => {
        this.activeIndex = nextIndex;
        setTimeout(() => {
          this.prevIndex = null;
          this.isAnimating = false;
        }, 500);
      }, 500);
    }
  }

  handleNext(): void {
    this.handleSlideChange((this.activeIndex + 1) % this.slides.length);
  }

  handlePrev(): void {
    this.handleSlideChange(
      (this.activeIndex - 1 + this.slides.length) % this.slides.length
    );
  }

  handleDotClick(index: number): void {
    if (index === this.activeIndex || this.isAnimating) return;
    this.handleSlideChange(index);
  }

  isExiting(index: number): boolean {
    return index === this.prevIndex;
  }

  getAnimationClasses(index: number, type: 'left' | 'right'): string {
    const isExiting = this.isExiting(index);

    if (type === 'left') {
      return isExiting ? 'animate-exit-left' : 'animate-enter-bottom';
    } else {
      return isExiting ? 'animate-exit-up' : 'animate-enter-right';
    }
  }

  trackByFn(index: number, item): number {
    return item.id;
  }
}
